import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useOrganization } from "@clerk/clerk-react";
import { client, handleClientMethod } from "../client";

export const useUpdateService = () => {
  const { organization } = useOrganization();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      serviceId,
      data,
    }: {
      serviceId: string;
      data: { cost?: number; title?: string };
    }) => {
      return await handleClientMethod(
        client.PATCH("/api/services/{id}", {
          params: {
            path: {
              id: serviceId,
            },
          },
          body: data,
        }),
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["/api/services", organization?.id],
      });
    },
  });
};
